import { render, staticRenderFns } from "./MhscodesFormHeader.vue?vue&type=template&id=086c184a"
import script from "./MhscodesFormHeader.vue?vue&type=script&lang=js"
export * from "./MhscodesFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports